import { Box, Flex, Text } from '@talos/kyoko';
import styled from 'styled-components';

export const CreditCardPrimaryCell = styled(Flex)`
  flex: 1 1 0;
  min-width: 0;
  color: ${({ theme }) => theme.colorTextImportant};
`;

export const CreditMetrics = styled(Flex)`
  align-items: stretch;
  justify-content: space-between;
  gap: ${({ theme }) => theme.spacing16}px;
  width: 100%;
`;

export const CreditMetricWrapper = styled(Flex)<{ $compact?: boolean; $progressBar?: boolean; $alignRight?: boolean }>`
  flex: ${({ $compact, $progressBar, $alignRight }) =>
    $compact || $alignRight ? '0 0 auto' : $progressBar ? '1 1 100%' : '1 1 0'};
  min-width: 0;
  flex-direction: column;
  gap: ${({ $progressBar, theme }) => ($progressBar ? 0 : theme.spacing2)}px;
  position: ${({ $progressBar }) => ($progressBar ? 'relative' : undefined)};
  overflow: hidden;
  align-items: ${({ $compact, $progressBar, $alignRight }) =>
    $compact || $alignRight ? 'flex-end' : $progressBar ? 'stretch' : undefined};
  text-align: ${({ $compact, $alignRight }) => ($compact || $alignRight ? 'right' : undefined)};
  margin-left: ${({ $compact }) => ($compact ? 'auto' : undefined)};

  &:has(> :last-child:empty) {
    display: none;
  }

  & > * {
    max-width: 100%;
  }
`;

export const CreditMetricValue = styled(Box)<{ $progressBar?: boolean }>`
  height: ${({ $progressBar }) => ($progressBar ? '34px' : undefined)};
  min-width: 0;

  & > * {
    width: ${({ $progressBar }) => ($progressBar ? '100%' : undefined)};
    height: ${({ $progressBar }) => ($progressBar ? '100%' : undefined)};
  }
`;

export const CreditProgressBarLabel = styled(Text)`
  position: absolute;
  left: 0;
  bottom: ${({ theme }) => theme.spacing4}px;
  max-width: 40%;
  pointer-events: none;
`;

export const CreditWarningCell = styled(Flex)`
  flex: 0 0 auto;
`;
